import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  useTheme,
  useMediaQuery,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Stack,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SpaIcon from "@mui/icons-material/Spa"; // Ícone relacionado à natureza/saúde
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export const Navbar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const navItems = ["Vantagens", "Coberturas", "Rede Credenciada", "FAQ"];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const logo = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <SpaIcon sx={{ color: theme.palette.primary.main, fontSize: 30 }} />
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: theme.palette.text.primary }}
      >
        Saúde Vital
      </Typography>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        backdropFilter: "blur(10px)",
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: "background-color 0.3s ease",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            height: 64,
          }}
        >
          {logo}

          {!isMobile && (
            <Stack direction="row" spacing={2} sx={{ mx: 3 }}>
              {navItems.map((item) => (
                <Button
                  key={item}
                  sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    "&:hover": {
                      color: theme.palette.primary.main,
                      backgroundColor: "transparent",
                    },
                  }}
                  href={`#${item.toLowerCase().replace(" ", "-")}`}
                >
                  {item}
                </Button>
              ))}
            </Stack>
          )}

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Button
              variant="contained"
              color="secondary"
              href="#formulario"
              startIcon={<WhatsAppIcon />}
              sx={{
                display: { xs: "none", sm: "flex" },
                boxShadow: "none",
                "&:hover": {
                  boxShadow: `0 4px 12px ${theme.palette.secondary.light}`,
                },
              }}
            >
              Falar com Consultor
            </Button>

            {isMobile && (
              <IconButton
                color="primary"
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerToggle}
                sx={{ ml: 1 }}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </Container>

      {/* Menu Mobile */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            width: "80%",
            maxWidth: "320px",
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
            p: 2,
            boxShadow: theme.shadows[3],
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            px: 1,
          }}
        >
          {logo}
          <IconButton
            onClick={handleDrawerToggle}
            sx={{ color: theme.palette.text.secondary }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <List sx={{ mb: 3 }}>
          {navItems.map((item) => (
            <ListItem
              button
              key={item}
              onClick={handleDrawerToggle}
              component="a"
              href={`#${item.toLowerCase().replace(" ", "-")}`}
              sx={{
                py: 1.5,
                borderRadius: 1,
                mb: 1,
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              <ListItemText
                primary={item}
                primaryTypographyProps={{
                  fontWeight: 500,
                  color: theme.palette.text.primary,
                }}
              />
            </ListItem>
          ))}
        </List>

        <Button
          variant="contained"
          color="secondary"
          fullWidth
          href="#formulario"
          startIcon={<WhatsAppIcon />}
          sx={{ py: 1.5 }}
        >
          Falar com Consultor
        </Button>
      </Drawer>
    </AppBar>
  );
};
